//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { InvoiceStatus, ReportStatus } from './Enums';

export class InvoiceSearchOptions extends ItemBase {
    IDs: string[] = [];
    SearchText: string | null = null;
    FamilyIDs: string[] = [];
    MinCreationDate: string | null = null;
    MaxCreationDate: string | null = null;
    MinStartDate: string | null = null;
    MaxStartDate: string | null = null;
    MinEndDate: string | null = null;
    MaxEndDate: string | null = null;
    Emailed: boolean | null = null;
    InvoiceStatuses: InvoiceStatus[] = [];
    ReportStatuses: ReportStatus[] = [];
    ZeroAmountDue: boolean | null = null;
    Archived: boolean | null = null;

    constructor(initializer?: Partial<InvoiceSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "InvoiceSearchOptions";
}
